// extracted by mini-css-extract-plugin
export default {"panel":"SlidingPanel_panel__keOkJ","left":"SlidingPanel_left__rJ5Lm","right":"SlidingPanel_right__iNI6T","bottom":"SlidingPanel_bottom__K35Oc"};